export default __webpack_public_path__ + "static/media/finance-logo-1-active.7afd74da.svg";